import React from 'react';

export default function BuyMeACoffee() {
    return ( 
        <a href="https://www.buymeacoffee.com/lucidare" target="_blank" rel="noreferrer">
            <img src="https://img.buymeacoffee.com/button-api/?text=Buy me a coffee&slug=lucidare&button_colour=1db954&font_colour=FFFFFF&font_family=Bree&outline_colour=000000&coffee_colour=6f4e37" alt="Buy Me a Coffee"/>
        </a>
    );
}
